import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FaqRoutingModule } from './faq-routing.module';
import {FaqComponent} from "../../app/layout/pages/faq/faq.component";
import {AboutUsComponent} from "../../app/layout/pages/about-us/about-us.component";
import {GeneralModule} from "../general/general.module";


@NgModule({
  declarations: [FaqComponent, AboutUsComponent],
  imports: [
    CommonModule,
    FaqRoutingModule,
      GeneralModule
  ]
})
export class FaqModule { }
